import React from 'react';

export type GoalOutcome = 'pending' | 'met' | 'exceeded' | 'not_met';

interface GoalOutcomeBadgeProps {
  outcome?: GoalOutcome;
  className?: string;
}

const GoalOutcomeBadge: React.FC<GoalOutcomeBadgeProps> = ({ outcome, className = '' }) => {
  if (!outcome || outcome === 'pending') return null;

  const getOutcomeColor = (outcome: GoalOutcome) => {
    switch (outcome) {
      case 'met':
        return 'text-green-600';
      case 'exceeded':
        return 'text-green-700';
      case 'not_met':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <span className={`text-xs font-medium ${getOutcomeColor(outcome)} ${className}`}>
      ({outcome.replace('_', ' ').toUpperCase()})
    </span>
  );
};

export default GoalOutcomeBadge;

